import { AuditDto } from '../../../api';
import { AuditListItemDto } from './audit-list-item.model';

/**
 * Audit State Model
 * 
 * This represents the state shape for audits in the store.
 */
export interface AuditsState {
  audits: AuditListItemDto[];
  selectedAudit: AuditDto | null;
  loading: boolean;
  /** Silent background refresh – list stays visible, no spinner */
  backgroundRefresh: boolean;
  error: string | null;
  lastUpdated: Date | null;
}

/**
 * Initial State
 */
export const initialAuditsState: AuditsState = {
  audits: [],
  selectedAudit: null,
  loading: false,
  backgroundRefresh: false,
  error: null,
  lastUpdated: null,
};
